module.exports = __webpack_public_path__ + "static/media/tre-kisko.3f02a712.svg";